import {MarginQuizQuestionController} from "./MarginQuizQuestionController";
import {BULL_CALL, STRIKE_PRICE, VOLATILITY} from "../MarginQuizQuestions";

export const StrikePrice = "tfStrikePriceQuestion";

export function strikePrice() {
    return {
        templateUrl: "app/quiz/margin/questions/StrikePrice.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: VolatilityQuestionController
    };
}

export class VolatilityQuestionController extends MarginQuizQuestionController {
    public config = STRIKE_PRICE;
}
